import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Image from '../../../Core/Image';
import Ctas from '../../../Core/Ctas';

export const Card = styled.li`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  max-width: 32.4375rem;
  border-radius: 0.75rem;
  background-color: ${({ $backgroundColor }) =>
    $backgroundColor ? themeGet(`colors.${$backgroundColor}`) : 'transparent'};
  overflow: hidden;
`;

export const ImageWrapper = styled.div``;

export const CardImage = styled(Image)`
  height: 100%;
  width: 100%;

  img {
    max-height: 320px;
  }

  ${Card}.icon & {
    min-height: 4.375rem;
    min-width: 4.375rem;
    height: 4.375rem;
    width: 4.375rem;
    margin: 1.8125rem 1.25rem 0;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      margin: 1.8125rem 2rem 0;
    }
  }
`;

export const Content = styled.div`
  position: relative;
  display: flex;
  height: 100%;
  flex-direction: column;
  padding: 1.8125rem 1.25rem;
  text-align: center;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    padding: 1.25rem 1.25rem;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    padding: 1.8125rem 1.5rem;
  }
`;

export const Title = styled.p`
  font-size: 1.375rem;
  font-weight: ${themeGet('fontWeights.medium')};
  margin-bottom: 1rem;
`;

export const Body = styled.p`
  font-size: 1.125rem;
`;

export const StyledCtas = styled(Ctas)`
  margin: auto 0 0;
`;
